<!--
  打印组件
  prop:{
    entityIdProp: { 数据id 必填
      required: true
    },
    moduleName: { //
      type: String
    },
    templateIdProp: { // 业务模板id 非必填，批量没有，单个打印需要
      type: Number,
      required: false
    },
    refType: { // 业务类型
      type: Number
    }
  }
 -->

<template>
  <div class="get-template">
    <el-dialog title="选择模板" :visible.sync="dialogVisible" :before-close="closePrint" :modal="false">
      <el-form label-width="140px" class="custom-form">
        <el-form-item label="模板名称">
          <el-select v-model="temp" placeholder="请选择模板" v-if="options">
            <el-option v-for="item in options" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="makeSurePrint"
      width="500px"
      :before-close="closePrint"
    >
      <span>您选择了 <span style="color:red;">{{this.entityId.length}}</span> 条数据，批量打印数量超过100条时，等待时间可能会比较长，确定打印吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPrint" type="danger">重新选择</el-button>
        <el-button @click="getTemplate" type="primary">确定打印</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import * as utils from 'src/utils'

export default {
  mounted () {
    this.alertLargeData() // 大数据确认是否打印
  },
  props: {
    entityIdProp: {
      required: true
    },
    moduleName: {
      type: String
    },
    templateIdProp: {
      type: Number
    },
    refType: {
      type: Number
    }
  },
  data () {
    return {
      dialogVisible: false,
      makeSurePrint: false,
      getData: {},
      temp: '',
      templateId: '',
      entityId: '',
      options: []
    }
  },
  methods: {
    closePrint () { // 关闭对话框前的回调
      this.$emit('closeDialog')
    },
    // 获取模板
    getTemplate () {
      let url = `/printTemplate/templateExist.do`
      let templateId = parseInt(this.templateIdProp) || '' // 批量打印走后面 业务模板id
      let refType = parseInt(this.refType) // 业务id
      let params = {
        entityId: this.entityId, // 批量打印走后面
        templateId: templateId,
        refType: refType
      }
      // 在Safari中，无法在回调函数中使用window.open
      api.post(url, params, (data) => {
        this.getData = data
        this.options = data.list
        this.templateId = data.list ? data.list[0].templateId : this.templateId
        this.temp = this.options ? this.options[0].id : 0
        // 如果仅有一个模板，则自动导出
        if (!this.options || this.options.length <= 1) { // 当不存在模板或者只存在一个模板时直接跳转到打印
          this.handleSubmit()
          return
        }
        this.$emit('print', false)
        this.dialogVisible = true
      })
    },
    // 提示打印数据过大
    alertLargeData () {
      this.entityId = String(this.entityIdProp).split(',') // 单条数据拆成数组
      if (this.entityId.length > 100) { // 数据超过100条，打开提示框
        this.makeSurePrint = true
      } else {
        this.getTemplate()
      }
    },
    cancelPrint () { // 取消打印 重新选择
      this.makeSurePrint = false
      this.$emit('closeDialog')
    },
    // 提交
    handleSubmit () {
      //  跳到新的打印模板
      let data = this.getData
      let url = ''
      let entityId = this.entityId.join(',') // 批量打印走后面，单独走前面
      if (data.ifnewtemplate === 1) {
        let winRef
        if (!utils.isDingTalk()) {
          winRef = window.open('', '_blank')
        }
//        let winRef = window.open('', '_blank')
        let entityIdCode = data.entityIdCode
        let corpidCode = data.corpidCode
        if (api.path) {
          url = 'http://localhost:8086/#/printTemplate?enable=' + 1 + '&entityId=' + entityId + '&refType=' + this.refType + '&templateId=' + this.templateId + '&entityIdCode=' + entityIdCode + '&corpidCode=' + corpidCode + '&id=' + this.temp
        } else {
          url = 'print/index.htm#/printTemplate?enable=' + 1 + '&entityId=' + entityId + '&refType=' + this.refType + '&templateId=' + this.templateId + '&entityIdCode=' + entityIdCode + '&corpidCode=' + corpidCode + '&id=' + this.temp
        }
        this.$nextTick(() => {
//          winRef.location = url
          if (utils.isDingTalk()) {
            let goUrl = utils.openBlankUrl(url)
            window.open(goUrl)
          } else {
            winRef.location = url
          }
        })
      } else {
        //  继续执行老的打印方法
        if (this.entityId.length !== 1) { // 没有打印模板并且点击批量时
          Message({
            type: 'error',
            message: '缺少打印模板，请添加模板后再打印'
          })
        } else { // 没有打印模板并且点击单个打印时
          let winRef
          if (!utils.isDingTalk()) {
            winRef = window.open('', '_blank')
          }
//          let winRef = window.open('', '_blank')
          const corpid = this.$cookies.get('corpid') || ''
          this.$nextTick(() => {
            if (this.moduleName === 'workReportApi') {
//              winRef.location = '/workReportApi/print.html?id=' + entityId
              let wUrl = '/workReportApi/print.html?id=' + entityId
              if (utils.isDingTalk()) {
                let goUrl = utils.openBlankUrl(wUrl)
                window.open(goUrl)
              } else {
                winRef.location = wUrl
              }
            } else {
//              winRef.location = `/${this.moduleName}/print.html?${this.moduleName}Id=${this.entityId}&corpid=${corpid}`
              let wUrl = `/${this.moduleName}/print.html?${this.moduleName}Id=${this.entityId}&corpid=${corpid}`
              if (utils.isDingTalk()) {
                let goUrl = utils.openBlankUrl(wUrl)
                window.open(goUrl)
              } else {
                winRef.location = wUrl
              }
            }
          })
        }
      }
      this.dialogVisible = false
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="less" scoped>
  .get-template {

    .el-dialog--small {
      width: 600px;
      z-index: 22600!important;
    }
  }
</style>



// WEBPACK FOOTER //
// print.vue?e25bf870